export enum AgentType {
    OUTBOUND="OUTBOUND",
    INBOUND="INBOUND"
}
